import React from "react";
import "./About.scss";
import { Switch, Route, withRouter } from "react-router-dom";
import withMotion from "../../Utils/withMotion";

//Panels
import PageNotFound from "../../404";
import Hero from "./Hero/Hero";
import ServiceAreas from "./Pages/ServiceAreas/ServiceAreas";
import Financing from "./Pages/Financing/Financing";

const About = () => {
  return (
    <>
      
      <div className="container-fluid page-about">
        <Hero />
        <Switch>
          <Route component={ServiceAreas} path="/about-us/service-areas" />
          <Route component={Financing} path="/about-us/financing" />
          <Route exact component={PageNotFound} path="*" />
        </Switch>
      </div>
    </>
  );
};

export default withRouter(withMotion(About));
